import React from 'react';
import get from 'lodash/get';
import {ErrorMessage, FastField} from 'formik';
import classNames from 'classnames';
import {FormattedMessage, useIntl} from 'react-intl';
import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../../res/translations/messages';
import Error from '../Error';
import PlusButton from './editor/PlusButton';
import MinusButton from './editor/MinusButton';
import MultiSelectField from '../form/MultiSelectField';
import {getCloudEventMessage} from './CloudEventText';

const SurveyCloudEventsSettingsType = ({form, name, push, remove}) => {
    const intl = useIntl();
    const values = get(form.values, name) || [];
    const cloudEventsOptions = React.useMemo(() => Object.values(constants.CLOUD_EVENTS).map((value) => ({
        value,
        label: intl.formatMessage(getCloudEventMessage(value)),
    })), [intl]);
    const addItem = React.useCallback(() => {
        push({events: [], url: '', token: '', identifier: ''});
    }, [push]);
    return (
        <table className="table table-sm table-borderless">
            <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col style={{width: 50}} />
            </colgroup>
            <thead>
                <tr>
                    <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.cloudEventsSettings.events} /></th>
                    <th><FormattedMessage {...messages.surveys.form.label.cloudEventsSettings.url} /></th>
                    <th><FormattedMessage {...messages.surveys.form.label.cloudEventsSettings.token} /></th>
                    <th><FormattedMessage {...messages.surveys.form.label.cloudEventsSettings.identifier} /></th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {values.map((item, index) => (
                    <tr key={index}>
                        <td className="pl-0">
                            <FastField id={`${name}-${index}-events`} name={`${name}.${index}.events`}
                                component={MultiSelectField} options={cloudEventsOptions} maxLength={24} />
                            <ErrorMessage name={`${name}.${index}.events`}>
                                {(message) => <Error reason={message.key} reasonParams={message.params} />}
                            </ErrorMessage>
                        </td>
                        <td>
                            <FastField id={`${name}.${index}.url`} name={`${name}.${index}.url`} type="url"
                                className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.url`) && get(form.touched, `${name}.${index}.url`)})} />
                            <ErrorMessage name={`${name}.${index}.url`}>
                                {(message) => <Error reason={message.key} reasonParams={message.params} />}
                            </ErrorMessage>
                        </td>
                        <td>
                            <FastField id={`${name}.${index}.token`} name={`${name}.${index}.token`} type="text"
                                className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.token`) && get(form.touched, `${name}.${index}.token`)})} />
                            <ErrorMessage name={`${name}.${index}.token`}>
                                {(message) => <Error reason={message.key} reasonParams={message.params} />}
                            </ErrorMessage>
                        </td>
                        <td>
                            <FastField id={`${name}.${index}.identifier`} name={`${name}.${index}.identifier`} type="text"
                                className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.identifier`) && get(form.touched, `${name}.${index}.identifier`)})} />
                            <ErrorMessage name={`${name}.${index}.identifier`}>
                                {(message) => <Error reason={message.key} reasonParams={message.params} />}
                            </ErrorMessage>
                        </td>
                        <td>
                            <div className="d-flex justify-content-center">
                                <div className="flex-column">
                                    <MinusButton remove={remove} index={index} />
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan="5" className="pl-0">
                        <PlusButton onClick={addItem}>
                            <FormattedMessage {...messages.surveys.form.label.cloudEventsSettings.add} />
                        </PlusButton>
                    </td>
                </tr>
            </tfoot>
        </table>
    );
};

export default SurveyCloudEventsSettingsType;
